import { differenceInCalendarDays, parseISO } from 'date-fns';

export type ExpiryClass = 'expired' | 'aboutExpire' | 'soonExpire' | 'notExpired';

/** How close an expiry date (`YYYY-MM-DD`) is, with the thresholds of legacy `SessionData.expiryClassification`. */
export const expiryClass = (expiryDate: string, today = new Date()): ExpiryClass => {
  const days = differenceInCalendarDays(parseISO(expiryDate), today);
  if (days < 0) return 'expired';
  if (days <= 90) return 'aboutExpire';
  if (days <= 270) return 'soonExpire';
  return 'notExpired';
};
